export const Sources = {
  default: '',
  rentalReference: 'RentalReference',
}
